/* eslint-disable no-unused-expressions */

// atoms
import(/* webpackChunkName: "back-to-top" */ '@/components/atoms/back-to-top');
import(/* webpackChunkName: "theme-switcher" */ '@/components/atoms/theme-switcher');
import(/* webpackChunkName: "font-observer" */ '@/components/atoms/font-observer');
import(/* webpackChunkName: "lazy-load" */ '@/components/atoms/lazy-load');

// molecules
import(/* webpackChunkName: "modal" */ '@/components/molecules/modal');
import(/* webpackChunkName: "language-picker" */ '@/components/molecules/language-picker');
import(/* webpackChunkName: "notice" */ '@/components/molecules/notice');
import(/* webpackChunkName: "cookie-banner" */ '@/components/molecules/cookie-banner');

// organisms
import(/* webpackChunkName: "header" */ '@/components/organisms/header');
